import * as React from "react";
import {
    Text,
    Image,
    View,
    StyleSheet,
    TouchableOpacity,
    Dimensions,
    ScrollView,
    Platform,
    Linking
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import { useNavigation } from "@react-navigation/native";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import InviteWebHeader from "../../components/InviteWebHeader";
import FooterBarWide from "../../components/footerBarWide";
import BackButtonTopWhite from "../../components/BackButtonTopWhite";
import { useSelector } from "react-redux";

export default function PromotionalLandingScreen() {
    const BGimage = require("../../assets/res/blue_bg.png");
    const MenuLogo = require("../../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
    const shellLogo = require("../../assets/images/shell/shellIcon.png");
    const investAuraIcon = require("../../assets/images/shell/investAuraIcon.png");
    const navigation = useNavigation();
    const win = Dimensions.get("window");

    const shellSignedup = useSelector((state) => state.user.userData.partners).find(obj => {
        if (obj.subscriptionName === 'shell') {
            if (obj.status != "inactive") return true;
            return false;
        }
    }) || false;

    const hasCharity = useSelector((state) => state.user.userData.subscriberDetails.charityId) != undefined;

    if (shellSignedup) {
        navigation.navigate("RedeemLanding");
    }
    return (
        <ScrollView style={styles.scrollView}>
            <View style={[GlobalStyles.containerN, { backgroundColor: "#ffffff" }]}>
                {/* <View style={GlobalStyles.backgroundContainer}>
                <Image style={GlobalStyles.backgroundImage} source={BGimage} />
            </View> */}
                {win.width > 768 ? (
                    <View style={GlobalStyles.fullHeaderBarY}>
                        <MenuBar data="1" />
                        <View style={GlobalStyles.headerContainerKLYellow}>
                        </View>
                    </View>
                ) : (
                    <View style={GlobalStyles.shellMobileHeaderContainer}>
                        <View style={styles.backButtonContainer}>
                            <BackButtonTopWhite />
                        </View>
                        <View style={styles.mainMenuLogoContainer}>
                            <Image style={styles.mainMenuLogo} source={MenuLogo} />
                        </View>
                        <View style={styles.forwardButtonContainer}>
                        </View>
                    </View>
                )}
                <View style={styles.bodyContainerFull}>
                    <View style={styles.fuelPartnerTextContainer}>
                        <Text style={styles.fuelPartnerTextStyle}>
                            Fuel Partner
                        </Text>
                    </View>
                    <View style={styles.ShellLogoContainer}>
                        <Image style={styles.shellLogo} source={shellLogo} />
                    </View>
                    <View style={styles.boldTextContainer}>
                        <Text style={styles.investtextStyleContainer}>
                            <View><Text style={styles.investtextStyle}>
                                Fuel your investment
                            </Text></View>
                            <View><Text style={styles.investtextStyle}>
                                with a 3¢ per litre
                            </Text></View>
                            <View><Text style={styles.investtextStyle}>
                                cash back reward with Aura.*
                            </Text></View>
                        </Text>
                    </View>
                    <View style={styles.InvestLogoContainer}>
                        <Image style={styles.investAuraIcon} source={investAuraIcon} />
                    </View>
                    <View style={styles.termTextContainer}>
                        <Text style={styles.tctextStyle}>
                            <Text style={styles.tctextStyle}>
                                *Offer valid on one transaction per day. Excludes LPG & Adblue.
                                Min 2L and max 150L of fuel per transaction. Cannot be used in
                                conjunction with other Viva Energy funded offers. See full&nbsp;
                            </Text>
                            <Text style={[styles.tctextStyle, { textDecorationLine: 'underline' }]}
                                onPress={() => {
                                    Platform.OS !== "web"
                                        ? Linking.openURL("https://aura.club/promotional-terms-and-conditions")
                                        : window.open("https://aura.club/promotional-terms-and-conditions", "_blank");
                                }}>
                                Terms and conditions apply.
                            </Text>
                        </Text>
                    </View>
                    <TouchableOpacity
                        style={styles.SubmitButtonStyle}
                        activeOpacity={0.5}
                        onPress={() => {
                            if(hasCharity)
                                navigation.navigate("Consent");
                            else
                                navigation.navigate("NoCharityNotifaction");
                        }}>
                        <Text style={styles.SubmitButtonTextStyle}
                        >
                            ACTIVATE OFFER
                        </Text>
                    </TouchableOpacity>
                    <View style={styles.webFooter}>
                        {win.width > 768 ? <FooterBarWide /> : null}
                    </View>
                </View>
            </View></ScrollView>
    )
}
const styles = StyleSheet.create({
    backButtonContainer: {
        paddingTop: 50,
        flex: 1,
        //paddingLeft: 10
    },
    forwardButtonContainer: {
        paddingTop: 50,
        flex: 1,
        //paddingLeft: 10
    },
    mainMenuLogoContainer: {
        flex: 3,
        alignSelf: "center",
        alignItems: "center",
        //paddingRight: 90,
        paddingTop: 30,
        paddingLeft: 10,
    },
    mainMenuLogo: {
        height: 70,
        width: 128,
    },
    bodyContainerFull: {
        flex: 1,
        flexDirection: "column",
        paddingTop: 30,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: "#FFFFFF",
        alignSelf: "center",
        width: "100%",
    },
    fuelPartnerTextContainer: {
        alignItems: "center",
        marginTop: -10
    },
    ShellLogoContainer: {
        flexDirection: "row",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 10,
    },
    shellLogo: {
        height: 88,
        width: 199,
        resizeMode: 'contain',
    },
    investAuraIcon: {
        height: 201,
        width: 218,
        resizeMode: 'contain',
    },
    boldTextContainer: {
        alignItems: "center",
        marginTop: 20,
    },
    InvestLogoContainer: {
        flexDirection: "row",
        alignSelf: "center",
        marginTop: 15
    },
    termTextContainer: {
        marginTop: 15,
        alignItems: "center",
    },
    SubmitButtonStyle: {
        paddingTop: 15,
        paddingBottom: 15,
        backgroundColor: "#FFC72C",
        borderRadius: 40,
        marginBottom: 10,
        marginTop: 30,
        marginLeft: 80,
        marginRight: 80,
        alignItems: "center",
        width: 280,
        alignSelf: "center",
    },
    SubmitButtonTextStyle: {
        color: "#000000",
        textAlign: "center",
        alignSelf: "center",
        fontFamily: "montserrat-bold",
        fontSize: 14,
    },
    textStyle: {
        fontFamily: "montserrat-regular",
        fontSize: 12,
        color: "black",
        textAlign: "center",
        marginBottom: 5,
        maxWidth: 300,
    },
    tctextStyle: {
        fontFamily: "montserrat-regular",
        fontSize: 10,
        color: "black",
        textAlign: "center",
        marginBottom: 5,
        maxWidth: 300,
    },
    investtextStyle: {
        fontFamily: "montserrat-bold",
        fontSize: 18,
        color: "black",
        textAlign: "center",

    },
    investtextStyleContainer: {
        fontFamily: "montserrat-bold",
        fontSize: 18,
        color: "black",
        textAlign: "center",
        alignItems: "center",
        marginBottom: 5,
        maxWidth: 300,
    },
    fuelPartnerTextStyle: {
        fontFamily: "montserrat-regular",
        textAlign: "center",
        color: "#757575",
        fontSize: 14,
        fontWeight: "bold"
    },

    scrollView: {
        backgroundColor: "#ffffff",
        flex: 1,
    },

    webFooter: {
        //backgroundColor: "green",
        // alignSelf: "flex-end",
        // alignContent: "flex-end",
    },
})